import { MolJob } from '@/packages/old_mol/entities/MolJob';
import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    molJob: new MolJob(),
    presets: null,
};
export var types = {
    SET_MOL_JOB: 'setMolJob',
    SET_PRESETS: 'setPresets',
};
export var oldMol = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
